import $ from "jquery";

$(document).ready(function() {
    var $boxOutter = $('.box-outter');
    var $boxInner = $('.box-inner');

    if ($boxOutter.length && $boxInner.length) {
      var offsetTop = 100; // Distance from top of the page when the element becomes fixed
    
      $(window).on('scroll', function() {
        var scrollTop = $(window).scrollTop();
        var boxOutterOffset = $boxOutter.offset().top;
        var boxOutterHeight = $boxOutter.outerHeight();
        var boxInnerHeight = $boxInner.outerHeight();

        // Check if we should fix the .box-inner when scrolling
        if (scrollTop > boxOutterOffset - offsetTop && scrollTop < (boxOutterOffset + boxOutterHeight - boxInnerHeight - offsetTop)) {
          //console.log('Box-inner is fixed');
          $boxInner.css({
            'position': 'fixed',
            'top': offsetTop + 'px',
            'width': $boxOutter.width() + 'px' // Maintain the same width
          });
        } else if (scrollTop >= (boxOutterOffset + boxOutterHeight - boxInnerHeight - offsetTop)) {
          // When the box-inner reaches the bottom of the box-outter
          //console.log('Box-inner reached the bottom');
          $boxInner.css({
            'position': 'absolute',
            'top': (boxOutterHeight - boxInnerHeight) + 'px',
            'width': '100%' // Reset width when it stops being fixed
          });
        } else {
          // Reset to normal positioning if before scrolling
          //console.log('Box-inner is in its original position');
          $boxInner.css({
            'position': 'relative',
            'top': '0',
            'width': '100%' // Reset width when not fixed
          });
        }
      });

    } else {
      
    }

    $(".copylink").click(function() {
        var pageURL = window.location.href;
      
        navigator.clipboard.writeText(pageURL)
            .then(function() {
                // Show the "Copied" message
                $("#copyMessage").fadeIn().delay(1000).fadeOut();
            })
            .catch(function(error) {
                console.error('Failed to copy page URL: ', error);
            });
      });

  });
  
  // Counter block
  document.addEventListener("DOMContentLoaded", function () {

      const counters = document.querySelectorAll(".js-counter");

      if (!("IntersectionObserver" in window)) return;

      const animateCounter = (counterEl) => {
          const valueEl = counterEl.querySelector(".counter-value");
          if (!valueEl || valueEl.classList.contains("is-counted")) return;

          valueEl.classList.add("is-counted");

          const target = parseInt(valueEl.dataset.target, 10);
          let current = 0;
          const duration = 1500;
          const startTime = performance.now();

          const update = (now) => {
              const progress = Math.min((now - startTime) / duration, 1);
              current = Math.floor(progress * target);
              valueEl.textContent = current.toLocaleString();

              if (progress < 1) {
                  requestAnimationFrame(update);
              } else {
                  valueEl.textContent = target.toLocaleString();
              }
          };

          requestAnimationFrame(update);
      };

      const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  entry.target.classList.add("is-visible");
                  animateCounter(entry.target);
                  observer.unobserve(entry.target); // run once
              }
          });
      }, {
          threshold: 0.4
      });

      counters.forEach(counter => observer.observe(counter));
  });

$(document).ready(function() {
    $('.content__body blockquote p').each(function() {
        var html = $(this).html();
        
        html = html.replace(/(–.*)$/m, '<span class="author">$1</span>');

        $(this).html(html);
    });
});